import {
    GET_ENTITE_REQUEST, GET_ENTITE_SUCCESS, GET_ENTITE_FAIL,
    GET_ALL_ENTITES_REQUEST, GET_ALL_ENTITES_SUCCESS, GET_ALL_ENTITES_FAIL,
    GET_ACTIVE_ENTITES_REQUEST, GET_ACTIVE_ENTITES_SUCCESS, GET_ACTIVE_ENTITES_FAIL,
    GET_ENTITES_BY_CATEGORY_REQUEST, GET_ENTITES_BY_CATEGORY_SUCCESS, GET_ENTITES_BY_CATEGORY_FAIL,
    CREATE_ENTITE_REQUEST, CREATE_ENTITE_SUCCESS, CREATE_ENTITE_FAIL,
    UPDATE_ENTITE_REQUEST, UPDATE_ENTITE_SUCCESS, UPDATE_ENTITE_FAIL,
    DELETE_ENTITE_REQUEST, DELETE_ENTITE_SUCCESS, DELETE_ENTITE_FAIL,
    SET_ENTITE_LOADING, UPDATE_ENTITE, GET_ORGANIGRAMME_SUCCESS,
    GET_ORGANIGRAMME_FAIL, EXPORT_ENTITIES_FAIL, IMPORT_ENTITIES_EXCEL_REQUEST, IMPORT_ENTITIES_EXCEL_SUCCESS,
    IMPORT_ENTITIES_EXCEL_FAIL, DOWNLOAD_ENTITIES_TEMPLATE_SUCCESS, EXPORT_ENTITIES_SUCCESS,
    DOWNLOAD_ENTITIES_TEMPLATE_FAIL, EXPORT_ENTITIES_REQUEST, DOWNLOAD_ENTITIES_TEMPLATE_REQUEST
} from '../actions/entitesActions';

const initialState = {
    entites: [],
    currentJob: null,
    loading: false,
    organigramme: [],
    organigrammeError: null,

    message: '',
    error: null
};

function entiteReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_ENTITE:
            return {
                ...state,
                loading: true,
                entite: action.entite
            };

        // --- SET LOADING ---
        case SET_ENTITE_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        // --- Récupérer un poste ---
        case GET_ENTITE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ORGANIGRAMME_SUCCESS:
            return {
                ...state,
                organigramme: action.payload || [],
                organigrammeError: null,
            };

        case GET_ORGANIGRAMME_FAIL:
            return {
                ...state,
                organigrammeError: action.payload,
            };
        case GET_ENTITE_SUCCESS:
            return {
                ...state,
                currentJob: action.payload,
                loading: false,
                message: 'Poste récupéré avec succès'
            };
        case GET_ENTITE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                message: 'Échec de la récupération'
            };

        // --- Récupérer tous les postes ---
        case GET_ALL_ENTITES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ALL_ENTITES_SUCCESS:
            return {
                ...state,
                entites: action.payload,
                loading: false,
            };
        case GET_ALL_ENTITES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case DOWNLOAD_ENTITIES_TEMPLATE_REQUEST:
        case EXPORT_ENTITIES_REQUEST:
            return { ...state, bulkLoading: true, error: null };

        case DOWNLOAD_ENTITIES_TEMPLATE_SUCCESS:
        case EXPORT_ENTITIES_SUCCESS:
            return { ...state, bulkLoading: false };

        case DOWNLOAD_ENTITIES_TEMPLATE_FAIL:
        case EXPORT_ENTITIES_FAIL:
            return { ...state, bulkLoading: false, error: action.payload || "Erreur" };

        case IMPORT_ENTITIES_EXCEL_REQUEST:
            return { ...state, bulkLoading: true, error: null, importResult: null };

        case IMPORT_ENTITIES_EXCEL_SUCCESS:
            return { ...state, bulkLoading: false, importResult: action.payload };

        case IMPORT_ENTITIES_EXCEL_FAIL:
            return { ...state, bulkLoading: false, error: action.payload || "Erreur import Excel" };
        // --- Récupérer postes actifs ---
        case GET_ACTIVE_ENTITES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ACTIVE_ENTITES_SUCCESS:
            return {
                ...state,
                entites: action.payload,
                loading: false,
                message: 'Postes actifs récupérés avec succès'
            };
        case GET_ACTIVE_ENTITES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer postes par catégorie ---
        case GET_ENTITES_BY_CATEGORY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ENTITES_BY_CATEGORY_SUCCESS:
            return {
                ...state,
                entites: action.payload,
                loading: false,
                message: 'Postes filtrés par catégorie avec succès'
            };
        case GET_ENTITES_BY_CATEGORY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Créer un poste ---
        case CREATE_ENTITE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CREATE_ENTITE_SUCCESS:
            return {
                ...state,
                entites: [...state.entites, action.payload],
                loading: false,
                message: 'Poste créé avec succès'
            };
        case CREATE_ENTITE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Mettre à jour un poste ---
        case UPDATE_ENTITE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_ENTITE_SUCCESS:
            return {
                ...state,
                entites: state.entites.map(entite =>
                    entite.id === action.payload.id ? action.payload : entite
                ),
                currentJob: state.currentJob?.id === action.payload.id
                    ? action.payload
                    : state.currentJob,
                loading: false,
                message: ''   // ← vide pour ne pas afficher l'alerte
            };
        case UPDATE_ENTITE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Supprimer un poste ---
        case DELETE_ENTITE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_ENTITE_SUCCESS:
            return {
                ...state,
                entites: state.entites.filter(entite => entite.id !== action.payload.entiteId),
                currentJob: state.currentJob?.id === action.payload.entiteId
                    ? null
                    : state.currentJob,
                loading: false,
                message: ''
            };
        case DELETE_ENTITE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state;
    }
}

export default entiteReducer;